"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.getRandomId = void 0;
const uuid_1 = require("uuid");
const getRandomId = () => (0, uuid_1.v4)();
exports.getRandomId = getRandomId;
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
